import React from "react";
import { cn } from "../../../lib/utils";
import { useConfiguratorContext } from "../../../hooks/configurator/configurator-context";
import { SelectionIndicator } from "./SelectionIndicator";
import { OptionInfo } from "./OptionInfo";
import { OptionThumbnail } from "./OptionThumbnail";
import { OptionPrice } from "./OptionPrice";
import { ConflictIndicator } from "./ConflictIndicator";

interface CardDisplayProps {
  options: any[];
  section: any;
}

export const CardDisplay: React.FC<CardDisplayProps> = ({
  options,
  section,
}) => {
  const configurator = useConfiguratorContext();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {options.map((option) => (
        <div
          key={option.id}
          className={cn(
            "cursor-pointer transition-all duration-200",
            section?.metadata?.uiTileBasis,
            !configurator.canSelectOption(section.id, option.id) &&
              "opacity-50 relative"
          )}
          title={
            !configurator.canSelectOption(section.id, option.id)
              ? "Selecting this option will replace incompatible selections"
              : ""
          }
        >
          <div
            onClick={() => configurator.toggleOption(section.id, option.id)}
            className={cn(
              "rounded-lg overflow-hidden relative shadow-sm hover:shadow-md transition-all duration-200 h-full flex flex-col border-2",
              configurator.isOptionSelected(option.id)
                ? "border-black shadow-md"
                : "border-gray-200 hover:border-gray-300"
            )}
          >
            <div className="aspect-video relative overflow-hidden">
              <OptionThumbnail option={option} />
              <OptionInfo option={option} />
              {configurator.isOptionSelected(option.id) && (
                <div className="absolute top-2 right-2 bg-black text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-bold">
                  ✓
                </div>
              )}
              <ConflictIndicator
                hasConflict={
                  !configurator.canSelectOption(section.id, option.id)
                }
              />
            </div>
            <div
              className={cn(
                "p-6 grow flex flex-col",
                configurator.isOptionSelected(option.id)
                  ? "bg-black text-white"
                  : "bg-white text-black"
              )}
            >
              <div className="grow">
                <p className="text-base mb-3" style={{ fontWeight: "300" }}>
                  {option.label}
                </p>
                <OptionPrice price={option?.price} />
              </div>
              <div className="flex justify-end mt-3">
                <SelectionIndicator
                  isSelected={configurator.isOptionSelected(option.id)}
                  isMultiple={section?.multiple}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
